import { render, staticRenderFns } from "./FetchArea.vue?vue&type=template&id=73747d9c&scoped=true&"
import script from "./FetchArea.vue?vue&type=script&lang=js&"
export * from "./FetchArea.vue?vue&type=script&lang=js&"
import style0 from "./FetchArea.vue?vue&type=style&index=0&id=73747d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73747d9c",
  null
  
)

export default component.exports